function parseOverviewData(data) {
  if((!data) || data.length==0){
      return null;
    }
    else{
      return JSON.stringify(data.portfoliosWithAccess != undefined ? data.portfoliosWithAccess : data);
    }

 }

function parseConsolidationRelationData(data) {
  
  if (!data) return null;
  return data.retCode == 0;

}

function serviceFactory({ api }) {
  const getConsolidationSetupData = ({metaData}) =>
    api
    .getConsolidationSetupData(metaData)
    .then(parseOverviewData);


  const setConsolidationSetupData = ({branchCode,pfId,relId,metaData}) => {
    const branchCodeObj = JSON.parse(branchCode);
    const pfIdObj = JSON.parse(pfId.replace(/\'/g, '\"'));
    return api
    .setConsolidationSetupData(branchCodeObj,pfIdObj,relId,metaData)
    .then(parseConsolidationRelationData);
  };


  return {
    getConsolidationSetupData,
    setConsolidationSetupData
  };
}

module.exports = serviceFactory;
